/**
 * Created by qlong on 9/9/2016.
 */
import helper from "../Helper.js"

const initialState = {
    categories: [],
    attributes: [],
    selectedOption: "",
    max_categories: 5,
    categoryColors: {},
    categoryColorSet: helper.getInitialColorSet(10,0),
    firstLoad: true,
}

export default function reducer(state=initialState,action) {
    switch (action.type) {
        case "ADD_CATEGORY":
            return {...state, categories: [...state.categories, action.payload]}
        case "REMOVE_CATEGORY":
            return {...state, categories: [...state.categories.filter((checkedBox) => checkedBox != action.payload)]}
        case "SET_SELECTED_OPTION":
            return {...state, selectedOption: action.payload}
        case "ADD_ATTRIBUTES":
            return {...state, attributes: [...new Set([...state.attributes.concat(action.payload)])]}
        case "SET_ATTRIBUTES":
            return {...state, attributes: [...new Set(action.payload)]}
        case "SET_CATEGORY_COLOR":
            return {...state, categoryColors: {...state.categoryColors, [action.payload.index]: action.payload.color }}
        case "DELETE_CATEGORY_COLOR":
            return helper.deleteObjectAttribute(state, action, "categoryColors")
        case "ADD_CATEGORY_COLOR_SET":
            return {...state, categoryColorSet: [action.payload].concat([...state.categoryColorSet])}
        case "POP_CATEGORY_COLOR_SET":
            return {...state, categoryColorSet: [...state.categoryColorSet.slice(1)]}
        case "CLEAR_FILTERS":
            return initialState
        case "SET_FIRST_LOAD_FALSE":
            return {...state, firstLoad: false}
    }

    return state
}



/** WEBPACK FOOTER **
 ** ./src/reducers/filterReducer.js
 **/